import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { fetchSystemDefaultTaskDbAdapter, updateSystemDefaultTaskDbAdapter } from '../../apis/system';
import { generateForm } from '../form/Form';
import { adapterProperties, MSSQL_FIELDS, ORACLE_FIELDS, POSTGRES_FIELDS, VALIDATE_DB_ADAPTERS } from './helpers';
import { getIn } from 'immutable';
import { handleFormErrors } from '../form/Form.helpers';

var dataSources = function dataSources() {
  return {
    defaultTaskDbAdapter: {
      fn: fetchSystemDefaultTaskDbAdapter,
      params: [],
      transform: function transform(result) {
        return result.adapter;
      }
    }
  };
};

var handleSubmit = function handleSubmit() {
  return function (values) {
    var type = values.get('type');
    var adapter = {
      type: type,
      properties: adapterProperties(values, type)
    };
    return updateSystemDefaultTaskDbAdapter({
      adapter: adapter
    }).then(handleFormErrors('adapter', 'There was an error saving the Adapter.'));
  };
};

var fields = function fields() {
  return function (_ref) {
    var defaultTaskDbAdapter = _ref.defaultTaskDbAdapter;
    return (defaultTaskDbAdapter || defaultTaskDbAdapter === null) && [{
      name: 'type',
      label: 'Task Adapter',
      type: 'select',
      options: VALIDATE_DB_ADAPTERS,
      initialValue: getIn(defaultTaskDbAdapter, ['type'], '')
    }].concat(_toConsumableArray(MSSQL_FIELDS('type', defaultTaskDbAdapter, [], null)), _toConsumableArray(ORACLE_FIELDS('type', defaultTaskDbAdapter, [], null)), _toConsumableArray(POSTGRES_FIELDS('type', defaultTaskDbAdapter, [], null)));
  };
};

export var SystemTaskAdapterForm = generateForm({
  formOptions: [],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
SystemTaskAdapterForm.displayName = 'SystemTaskAdapterForm';